module.exports = __webpack_public_path__ + "img/yml_gallery12.0c2c9678.jpg";